import BorderButton from '@/Component/Common/Forms/BorderButton';
import PrimaryButton from '@/Component/Common/Forms/PrimaryButton';
import Modal from '@/Component/Common/Modal';
import { LoaderSVG } from '@/Component/Common/SVGs/CommonSVG';
import { ChangeInfluencerStatusAPI } from '@/Utils/APIRequest/Endpoints';
import usePost from '@/Utils/Hooks/usePost';
import { useEffect, useState } from 'react';

const ConfirmModal = (props) => {
    const { confirmModalOpen, setConfirmModalOpen, translations } = props;
    const [isOfflinePayment, setIsOfflinePayment] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);

    useEffect(() => {
        if (!confirmModalOpen) {
            setIsSuccess(false);
            setIsOfflinePayment(false);
        }
    }, [confirmModalOpen]);

    // API Patch
    const { isPending, mutate } = usePost(`${ChangeInfluencerStatusAPI}/${confirmModalOpen?.id}`, null, (response) => {
        if (response.status == 200 || response.status == 201) {
            confirmModalOpen?.JobDetailDataRefetch();
            setIsSuccess(true);
        }
    }, 'Patch');

    const handleConfirm = () => {
        let obj: any = {
            status: "completion_request",
            payment_mode: confirmModalOpen?.offline_payment == 'forced' ? true : isOfflinePayment
        }
        mutate(obj)
    }

    const handleCloseSuccess = () => {
        setIsSuccess(false);
        setConfirmModalOpen(null);
    }

    return (
        <Modal modalSize="w-1/1 md:w-2/3 lg:w-1/2 xl:w-1/3 2xl:w-1/4" modal={confirmModalOpen} setModal={setConfirmModalOpen}>
            {isSuccess ? (
                <div className="flex flex-col gap-4">
                    <p className="text-base">{translations?.completionSuccessPopupMessage1}</p>
                    <p className="text-base" dangerouslySetInnerHTML={{ __html: translations?.completionSuccessPopupMessage2 }}></p>
                    <div className="flex items-center justify-center w-full mt-2">
                        <PrimaryButton onClick={handleCloseSuccess} customClass='!w-full flex items-center justify-center gap-1.5 !bg-closed !border-closed !px-0 !max-w-48' disabled={isPending}>
                            {translations?.gotItThanks}
                        </PrimaryButton>
                    </div>
                </div>
            ) : (
                <div className="flex flex-col gap-3">
                    <h5 className="text-xl font-semibold">{translations?.confirmCompletionDeclaration}</h5>
                    <p className='font-medium'>{translations?.confirmCompletionDeclarationMessage1}</p>
                    <p className='text-sm font-medium'>{translations?.confirmCompletionDeclarationMessage2}</p>
                    <p className='text-sm font-medium'>{translations?.confirmCompletionDeclarationMessage3}</p>
                    <p className='text-sm font-medium' dangerouslySetInnerHTML={{ __html: translations?.confirmCompletionDeclarationMessage4 }}></p>

                    {confirmModalOpen?.offline_payment == 'yes' && confirmModalOpen?.influencer_budget > 0 && (
                        <label className="flex items-start space-x-2 cursor-pointer my-4">
                            <div className="relative">
                                <input type="checkbox" name="payment_mode" checked={isOfflinePayment} onChange={(e) => setIsOfflinePayment(e.target.checked)} className="hidden peer" />
                                <div className="w-5 h-5 border border-black rounded-sm flex items-center justify-center peer-checked:bg-primary peer-checked:border-primary transition-all">
                                    <svg className="w-4 h-4 text-white peer-checked:block" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                                    </svg>
                                </div>
                            </div>
                            <span className='text-sm'>{translations?.offlinePaymentMessage}</span>
                        </label>
                    )}

                    <div className="flex items-center justify-center sm:gap-3.5 gap-1.5 w-full mt-3">
                        <BorderButton onClick={() => setConfirmModalOpen((prev) => prev !== confirmModalOpen)} customClass='!w-full !max-w-44'>{translations?.cancel}</BorderButton>
                        <PrimaryButton onClick={handleConfirm} customClass='!w-full flex items-center justify-center gap-1.5 !bg-closed !border-closed !px-0 !max-w-48' disabled={isPending}>
                            {translations?.confirm}
                            {isPending && <LoaderSVG />}
                        </PrimaryButton>
                    </div>
                </div>
            )}
        </Modal>
    )
}

export default ConfirmModal
